import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Clock4, Headset, Phone } from 'lucide-react';

const styles = `
  .fab-wrap {
    position: fixed;
    bottom: 4rem;
    right: 3rem;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    z-index: 1000;
  }

  .fab-panel {
    width: 300px;
    border: 1px solid #e5e7eb;
    background: #ffffff;
    border-radius: 16px;
    display: none;
    overflow: hidden;
    margin-bottom: 12px;
    transform: scale(0.88) translateY(12px);
    transform-origin: bottom right;
    pointer-events: none;
    transition: transform 0.22s cubic-bezier(0.22, 1, 0.36, 1), opacity 0.18s ease;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  }

  .fab-panel.fab-panel--visible {
    transform: scale(1) translateY(0);
    display: block;
    pointer-events: all;
  }

  .fab-panel__header {
    padding: 1rem 1.25rem 0.75rem;
    border-bottom: 1px solid #f3f4f6;
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .fab-panel__avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #f3f4f6;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    font-size: 20px;
  }

  .fab-panel__title {
    font-size: 14px;
    font-weight: 600;
    color: #111827;
    margin: 0;
  }

  .fab-panel__status {
    font-size: 12px;
    color: #6b7280;
    margin: 2px 0 0;
    display: flex;
    align-items: center;
    gap: 5px;
  }

  .fab-panel__status-dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: #16a34a;
    display: inline-block;
    flex-shrink: 0;
  }

  .fab-panel__body {
    padding: 1rem 1.25rem;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .fab-info-row {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    background: #f9fafb;
    border-radius: 10px;
    padding: 0.65rem 0.9rem;
  }

  .fab-info-row__icon {
    font-size: 16px;
    color: #9ca3af;
    margin-top: 1px;
    flex-shrink: 0;
    width: 18px;
    text-align: center;
  }

  .fab-info-row__label {
    font-size: 11px;
    color: #9ca3af;
    margin: 0;
  }

  .fab-info-row__value {
    font-size: 13px;
    color: #111827;
    font-weight: 500;
    margin: 2px 0 0;
  }

  .fab-chat-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    padding: 0.7rem;
    background: #D55B15;
    color: #ffffff;
    border: none;
    border-radius: 10px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.15s;
    margin-top: 4px;
  }


  .fab-btn {
    width: 76px;
    height: 86px;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    position: relative;
    background:transparent;
    transition: transform 0.2s, background 0.2s;
  }

  .fab-btn:hover {
    transform: scale(1.07);
  }

  .fab-btn:active {
    transform: scale(0.97);
  }


`;

interface InfoRowProps {
  icon: React.ReactNode;
  label: string;
  value: string;
}

function InfoRow({ icon, label, value }: InfoRowProps) {
  return (
    <div className="fab-info-row">
      <span className="fab-info-row__icon">{icon}</span>
      <div>
        <p className="fab-info-row__label">{label}</p>
        <p className="fab-info-row__value">{value}</p>
      </div>
    </div>
  );
}

interface FloatingSupportProps {
  titulo?: string;
  horario?: string;
  telefone?: string;
  url?: string;
}

export default function FloatingSupport({
    titulo = "Suporte - CIP",
    horario = "Seg - Sex, 08h - 18h",
    telefone = "+244 ",
    url = "https://cip.vamsolucoes.com/chat",

}: FloatingSupportProps) {
  const [aberto, setAberto] = useState(false); 
  const navigate = useNavigate();

  const togglePanel = () => setAberto((prev) => !prev);

  const handleAbrirChat = () => {
    window.open(url, '_blank');
    setAberto(false);
  };

  return (
    <>
      <style>{styles}</style>

      <div className="fab-wrap">
        <div className={`fab-panel${aberto ? " fab-panel--visible" : ""}`}>
          <div className="fab-panel__header">
            <div className="fab-panel__avatar" aria-hidden="true">
              <Headset className="text-[#D55B15]" size={25} />
            </div>
            <div>
              <p className="fab-panel__title">{titulo}</p>
              {/* <p className="fab-panel__status">
                                <span className="fab-panel__status-dot" />
                                Disponível agora
                            </p> */}
            </div>
          </div>

          <div className="fab-panel__body">
            <InfoRow icon={<Clock4 className="text-[#D55B15]" size={20} />} label="Horário de atendimento" value={horario} />
            <InfoRow icon={<Phone className="text-[#D55B15]" size={20} />} label="Linha direta" value={telefone} />


            <button className="fab-chat-btn" onClick={handleAbrirChat}>
              Abrir chat
            </button>
          </div>
        </div>

        <button
          className="fab-btn"
          onClick={togglePanel}
          aria-label={aberto ? "Fechar suporte" : "Abrir suporte"}
          aria-expanded={aberto}
        >
          <img src={'/icones/OFAfaleconosco2.svg'} alt="img" />
        </button>
      </div>
    </>
  );
}